import React from 'react';
import IndicatorCoverateMonitorTable from './IndicatorCoverageratioMonitorTable.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  useIndicatorCoverageRatioQuery,
  type IndicatorCoverageRatioPageModel,
} from '../../../../api/rs-hg/esg';

export interface IndicatorCoverageRatioMonitorUnderlyingTableData {
  gmid: string;
  gross_exposure_percentage: number;
  indicator: string;
  isin: string;
  position_id: string;
  position_name: string;
  value: string;
}

export interface IndicatorCoverageRatioMonitorTableData {
  coverage_ratio_percentage: number;
  description: string;
  indicator: string;
  indicator_name: string;
  limit: number;
  limit_type: string;
  pass_fail: string;
  total_covered_exposure_percentage: number;
  total_gross_exposure_percentage: number;
  unit: string;
  value: string;
  underlying: IndicatorCoverageRatioMonitorUnderlyingTableData[];
}

const IndicatorCoverageRatioMonitor: React.FC<FundInfoComponentProps> = ({
  fundId,
  positionDate,
}) => {
  const coverageRatioQuery = useIndicatorCoverageRatioQuery(
    fundId,
    positionDate,
  );

  return (
    <QueryBoundary<IndicatorCoverageRatioPageModel>
      isLoading={coverageRatioQuery.isLoading}
      isFetching={coverageRatioQuery.isFetching}
      isError={coverageRatioQuery.isError}
      error={coverageRatioQuery.error}
      data={
        coverageRatioQuery.data?.data?.data?.length
          ? coverageRatioQuery.data
          : null
      }
      loadingMessages={['Loading Indicator Coverage Ratio Data']}
      errorMessage="No Data Available."
      noDataMessage="No Data Available."
    >
      {(pageModel) => (
        <IndicatorCoverateMonitorTable data={pageModel.data} />
      )}
    </QueryBoundary>
  );
};

export default IndicatorCoverageRatioMonitor;
